// PolicyPrintoutSuccessResponse
import { axiosInstance } from "./axiosConfig";
import { isAxiosError } from "axios";

interface PolicyPrintoutSuccessResponse {
    url?: string;
    file?: Blob;
    message?: string;
    pdf_base64?: string;
}



// INTERFACE_SUCCESS_RESPONSE
interface PolicyPrintoutSuccessResponse {
    url?: string;
    file?: Blob;
    message?: string;
    pdf_base64?: string;
    policy_number?: string;
}

// VALIDATION_ERROR
interface ErrorDetail {
    code: string;
    detail: string;
    attr: string;
}

// GENERIC_ERROR_RESPONSE
interface GenericErrorResponse {
    error?: string;
}

// INTERFACE_ERROR_RESPONSE
interface PolicyPrintoutErrorResponse {
    type: 'validation_error';
    errors: ErrorDetail[];
}

// INTERFACE_RESULT
export interface PolicyPrintoutResult {
    data: PolicyPrintoutSuccessResponse | PolicyPrintoutErrorResponse | GenericErrorResponse;
    status: number;
}

// GET POLICY PRINTOUT API
export const GetPolicyPrintout = async (
    policyNumber: string,
    language: 'az' | 'en' = 'az'
): Promise<PolicyPrintoutResult> => {
    try {
        const response = await axiosInstance.get<PolicyPrintoutSuccessResponse>(
            `core/policy-printout/${policyNumber}`,
            {
                headers: {
                    'Accept-Language': language,
                },
            }
        );

        return {
            data: response.data,
            status: response.status
        };

    } catch (error) {
        if (isAxiosError(error)) {
            if (error.response) {
                return {
                    data: error.response.data || { error: 'Bilinməyən xəta baş verdi' },
                    status: error.response.status
                };
            }

            if (error.request) {
                return {
                    data: { error: 'Şəbəkə xətası - cavab alınmadı' },
                    status: 0
                };
            }
        }

        return {
            data: {
                error: error instanceof Error ? error.message : 'Gözlənilməz xəta baş verdi'
            },
            status: -1
        };
    }
};